import React from "react";
import { createComponent } from "@lit/react";
import { BeamProductDetailsPage as _BeamProductDetailsPage } from "./index";

export const BeamProductDetailsPage = createComponent({
  tagName: _BeamProductDetailsPage.tagName,
  elementClass: _BeamProductDetailsPage,
  react: React,
  events: {},
});

export default BeamProductDetailsPage; // default alias for use with async import utils like next/dynamic and react.lazy
